/**
 * Gets the configuration of a package.
 * @param packageIdentifier - Identifier of the package.
 * @returns Configuration of the package.
 */
export function getConfig(packageIdentifier) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (typeof window === 'undefined') {
        return null;
    }
    if ((_b = (_a = window.SYDLE) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b[packageIdentifier]) {
        return (_d = (_c = window.SYDLE) === null || _c === void 0 ? void 0 : _c.config) === null || _d === void 0 ? void 0 : _d[packageIdentifier];
    }
    if ((_f = (_e = window.sydleApp) === null || _e === void 0 ? void 0 : _e.config) === null || _f === void 0 ? void 0 : _f[packageIdentifier]) {
        return (_h = (_g = window.sydleApp) === null || _g === void 0 ? void 0 : _g.config) === null || _h === void 0 ? void 0 : _h[packageIdentifier];
    }
    if (window[packageIdentifier]) {
        return window[packageIdentifier];
    }
    return null;
}
